import React, { useEffect, useRef } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import { stopBackgroundScrolling } from '../../../common/utils/app.utils';
const CustomModal = (props) => {
  let { customPopupTitle, customPopupMsg, closeCustomPopup, submitCustomPopup, onLoad, isLoading = false } = props;
  const closeCustomModal = () => {
    stopBackgroundScrolling(false);
    closeCustomPopup();
  };
  const submitCustomModal = () => {
    stopBackgroundScrolling(false);
    submitCustomPopup();
  };
  useEffect(() => {
    stopBackgroundScrolling(true);
    onLoad && onLoad();
  }, []);
  return (
    <React.Fragment>
      <div className="modal-custom open">
        <div className="modal_dialog contract_modal">
          <div className="modal_content">
            <div className="modal_header">
              <h5>{customPopupTitle ? customPopupTitle : 'Proceed to Booking Summary'}</h5>
            </div>
            <div className="modal_body">
              <div className="plan_condition custom-modal-dec">{customPopupMsg}</div>
              <div className="next_step">
                <Button disabled={isLoading} variant="outlinebtn" onClick={closeCustomModal}>
                  Cancel
                </Button>
                <Button disabled={isLoading} variant="activebtn" onClick={submitCustomModal}>
                  Yes
                  {isLoading && <span className="loading_icon"></span>}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomModal;
